import React, { useState, FC, useEffect } from "react";
import { Icon, TooltipComponent } from "../../components/Component";
import FormatDate from "../masters/DateFormater";

import { useNavigate } from "react-router";
import statusMapper from "./StatusMapper";

import DispatchAside from "./dispatchAside";
import { formatCurrency } from "../../utils/Utils";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import { Button } from "reactstrap";
import { TableColumnsType } from "antd";
import { useSelector } from "react-redux";

const ViewPendingApprovalsGRN: FC = () => {
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const [siteOptions, setSiteOptions] = useState<any>([]);

  const { data: currentUser } = useSelector((state: any) => state.currentUser);

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const _siteOptions = siteAccessibility.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSiteOptions(_siteOptions);
      }
    }
  }, [currentUser]);

  const [columns, setColumns] = useState<TableColumnsType<any>>([
    {
      title: "GRN #",
      dataIndex: "grnId",
      key: "grnId",
      width: 250,
      fixed: "left",
    },
    {
      title: "Invoice #",
      dataIndex: "invoiceId",
      key: "invoiceId",
      width: 250,
      render: (text: any, record: any) => {
        if (!text && !record.invoiceNumber) return <span>-</span>;
        const invoiceId = text || record.invoiceId;
        const invoiceNumber = record.invoiceNumber;
        return (
          <span
            className="inlineTableCellLink"
            style={{ cursor: "pointer", color: "#2263b3" }}
            onClick={() => {
              if (invoiceNumber) {
                navigate(`/view-invoice/${invoiceNumber}`, {
                  state: { previousPath: "/delivered-dispatch-list" },
                });
              }
            }}
          >
            {invoiceId}
          </span>
        );
      },
    },
    {
      title: "Order #",
      dataIndex: "orderId",
      key: "orderId",
      width: 250,
      render: (text: any, record: any) => {
        if (!text && !record.orderNumber) return <span>-</span>;
        const orderId = text || record.orderId;
        const orderNumber = record.orderNumber;
        return (
          <span
            className="inlineTableCellLink"
            style={{ cursor: "pointer", color: "#2263b3" }}
            onClick={() => {
              if (orderNumber) {
                navigate(`/view-purchase-order/${orderNumber}`, {
                  state: { previousPath: "/delivered-dispatch-list" },
                });
              }
            }}
          >
            {orderId}
          </span>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date) => <span>{FormatDate(date)}</span>,
      width: 170,
    },
    {
      title: "Supplier",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`supplierName-tooltip-${index}`}>
              {text?.length > 20 ? `${text?.substring(0, 25)}... ` : text}
            </span>
            {text?.length > 20 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`supplierName-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Basic Amount",
      dataIndex: "basicAmount",
      key: "basicAmount",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, record.currencyCode)}</span>
        </div>
      ),
    },

    {
      title: "SGST",
      dataIndex: "sgst",
      key: "sgst",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {Number(record?.sgst) && Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "CGST",
      dataIndex: "cgst",
      key: "cgst",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {Number(record?.sgst) && Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "IGST",
      dataIndex: "igst",
      key: "igst",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {!Number(record?.sgst) && !Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },

    {
      title: "Gross Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 250,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, record.currencyCode)}</span>
        </div>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "approvalStatus",
      key: "approvalStatus",
      width: 170,
      fixed: "right",
      render: (status: any) => {
        const _status = statusMapper[status]?.buyer;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 80,
      render: (text: any, record: any) => (
        <>
          <Button
            size="sm"
            color=""
            onClick={() => {
              setSm(false);
              navigate(`/view-grn-pending-approval/${record.dispatchNumber}`, {
                state: { hideAside: true, previousPath: "/pending-approvals-grn-list" },
              });
            }}
          >
            <Icon name="focus" />
          </Button>
        </>
      ),
    },
  ]);

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="pending-approvals-grn-list"
      title="Pending Approvals GRN's"
      columns={columns}
      sideNavigation={
        <div
          className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${sm ? "content-active" : ""
            }`}
        >
          <DispatchAside updateSm={setSm} sm={sm} />
        </div>
      }
      selectFilters={[
        {
          title: "Site",
          placeholder: "Select Site",
          options: siteOptions,
          selectionMode: "multiple",
        },
      ]}
      extra={{
        tableScrollX: 1100,
        dateRange: true,
        dataFilterTootip: "Filtering based on GRN date",
      }}
    />
  );
};

export default ViewPendingApprovalsGRN;
